import { defineMessages } from 'react-intl';

import LinkMapEdit from './LinkMapEdit';
import LinkMapView from './LinkMapView';
import { linkMapSchema } from './schema';

import mapSVG from './icons/icon.svg';

defineMessages({
  linkMap: {
    id: 'Link map',
    defaultMessage: 'Link map',
  },
});

const applyConfig = (config) => {
  config.blocks.blocksConfig.linkMap = {
    id: 'linkMap',
    title: 'Link map',
    group: 'govbr',
    icon: mapSVG,
    view: LinkMapView,
    edit: LinkMapEdit,
    blockSchema: linkMapSchema,
    restricted: false,
    mostUsed: false,
    sidebarTab: 1,
    security: {
      addPermission: [],
      view: [],
    },
  };
  return config;
};

export default applyConfig;
